import React, { useState } from 'react';
import { Sparkles, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import TrainingWishForm from './TrainingWishForm';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';

/**
 * Prominenter Banner-CTA für das Wunsch-Kurs-System.
 * Auf `/kurse` und im Chef-Cockpit einzubinden.
 */
export const CourseWishBanner = ({ variant = 'default' }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div
        className="relative overflow-hidden rounded-xl border border-yellow-500/40 bg-gradient-to-r from-yellow-500/10 via-amber-500/10 to-yellow-500/10 p-5 sm:p-6 shadow-lg shadow-yellow-500/10"
        data-testid="course-wish-banner"
      >
        <div className="absolute -top-6 -right-6 opacity-20">
          <Sparkles className="w-32 h-32 text-yellow-400" />
        </div>
        <div className="relative flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-2">
              <Sparkles className="w-5 h-5 text-yellow-400" />
              <span className="text-xs uppercase tracking-wider text-yellow-300 font-semibold">
                Wir bauen deine Schulung
              </span>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-white mb-1">
              Fehlt dir eine spezielle Unterweisung für deinen Betrieb?
            </h3>
            <p className="text-gray-300 text-sm sm:text-base">
              Reiche deinen Kurswunsch ein — wir produzieren ihn für dich und stellen ihn allen Kunden zur Verfügung.
              {variant === 'cockpit' ? ' Kein Aufpreis für A-Kunden.' : ' Der meistgewünschte Kurs wird als nächstes produziert.'}
            </p>
          </div>
          <Button
            onClick={() => setOpen(true)}
            size="lg"
            className="bg-yellow-500 text-black hover:bg-yellow-400 font-bold shadow-md shrink-0"
            data-testid="wish-banner-cta-btn"
          >
            Kurswunsch einreichen
            <ArrowRight className="ml-2 w-4 h-4" />
          </Button>
        </div>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-gray-900 border-yellow-500/30 max-w-lg">
          <DialogHeader>
            <DialogTitle className="text-white text-xl">Kurswunsch einreichen</DialogTitle>
          </DialogHeader>
          <TrainingWishForm variant="inline" isAuthenticated={true} />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CourseWishBanner;
